<template lang="pug">
.search-field
  b-input(
    v-model="query"
    :icon="icon"
    @change.native="changeHandler"
  )
  a.reset-button(
    v-if="query"
    @click="resetHandler"
  )
    b-icon(icon="close-circle-outline")
</template>

<script>

export default {
  name: 'search-field',
  created() {
    this.query = this.value;
  },
  data() {
    return {
      query: null,
    };
  },
  methods: {
    changeHandler($event) {
      this.$emit('change', $event.target.value);
    },
    resetHandler() {
      this.query = null;
      this.$emit('reset');
    },
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'magnify',
    },
    value: {
      type: String,
      default: null,
    },
  },
  watch: {
    value(val) {
      if (!val) this.query = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-field {
  position: relative;
  .reset-button {
    position: absolute;
    z-index: 100;
    right: 6px;
    top: 6px;
    color: $grey-lighter;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/SearchField.vue